import ToggleCustomBuy from "./view/Other/ToggleCustomBuy";
import ChangePassword from "./view/Other/ChangePassword";
import Receipt from "./view/Other/Receipt/Receipt";
import SelectMode from "./view/Other/SelectMode";
import ServiceMode from "./view/Other/ServiceMode";
import BaseUrl from "./view/Other/BaseUrl";
import ToggleShowQrcode from "./view/Other/ToggleShowQrcode";
import SelectLang from "./view/Other/SelectLang";

export default function Other() {


    return (
        <section className={"other-container"}>
            <SelectLang/>
            <SelectMode/>
            <ToggleCustomBuy/>
            <Receipt/>
            <ChangePassword/>
            <ServiceMode/>
            <BaseUrl/>
            <ToggleShowQrcode/>
        </section>
    )
}